import React from 'react';
import { TextField, IconButton, InputAdornment, CircularProgress } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Controller } from 'react-hook-form';

const DocIdField = ({ control, errors, fetchHighestDocId, isLoadingDocId }) => {
  return (
    <Controller
      name="docId"
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          fullWidth
          label="DOCID"
          type="number"
          placeholder="Enter document ID"
          error={!!errors.docId}
          helperText={errors.docId?.message}
          InputProps={{
            inputProps: {
              min: 0,
              step: 1,
              onWheel: (e) => e.target.blur(),
            },
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={fetchHighestDocId}
                  disabled={isLoadingDocId}
                  edge="end"
                >
                  {isLoadingDocId ? (
                    <CircularProgress size={20} />
                  ) : (
                    <RefreshIcon />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
};

export default React.memo(DocIdField); 